// Entry point for the build script in your package.json

import "@hotwired/turbo-rails"
import 'lib/turbo-extensions'
import 'lib/cable'
import SyncObserver from 'lib/sync_observer'
import 'lib/turbo-stream-animations'
import 'lib/choices-select'

import 'controllers'
import '../components'

Turbo.config.drive.progressBarDelay = 150

function startSyncObserver() {
  const accountId = Number(document.querySelector('meta[name="current-account"]')?.content)
  const userId = Number(document.querySelector('meta[name="current-user"]')?.content)

  if (!accountId || !userId) return

  window.syncObserver = new SyncObserver(accountId, userId)
  window.syncObserver.connect()
}

startSyncObserver()

if (window?.MinuteDock?.debug) {
  [ 'click', 'before-visit', 'visit', 'before-cache', 'before-render', 'render', 'load',
    'morph', 'before-morph-element', 'before-morph-attribute', 'morph-element',
    'submit-start', 'submit-end',
    'before-frame-render', 'frame-render', 'frame-load', 'frame-missing',
    'before-stream-render',
    'before-fetch-request', 'before-fetch-response', 'before-prefetch', 'fetch-request-error',
    'before-morph-element', 'before-morph-attribute', 'morph-element'
  ].forEach(eventName => document.addEventListener(`turbo:${eventName}`, event => {
    console.log(`turbo:${eventName}`, event)
  }))
}

window.bundleLoading?.loaded("application")
